import React, { useState } from 'react'
import Button from '@mui/material/Button'
// import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
// import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import ComboBox from '../../../Components/ComboBox'
import { Input } from '../../../Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import urls from '../../../utils/urls'
// import { Box } from '@mui/material'
import { currentDate } from '../../../utils/helpers'
import { useMediaQuery, useTheme } from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle'
export default function CreateOperationForm({ setOperations }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)
  const [typeObject, setTypeObject] = useState(0)
  const [accounts, setAccounts] = useState([])
  const [tasks, setTasks] = useState([])
  const [types, setTypes] = useState([])
  const [typesTemps, setTypesTemps] = useState([])
  const [immobiliers, setImmobiliers] = useState([])
  const [vehicules, setVehicules] = useState([])
  const [planMaintenance, setPlanMaintenance] = useState([])
  const [parcoursPro, setParcoursPro] = useState([])
  const [file, setFile] = useState(null)
  const [selectedTypeDoc, setSelectedTypeDoc] = useState(null)
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Type: '',
      Affectation: '',
      Immobilier: '',
      Vehicules: '',
      PlanMaintenance: '',
      ParcoursPro: '',
      TaskMesToDo: '',
      Nom: '',
      Description: '',
      Externe: '',
      Datedéchéance: currentDate(),
    },
  })
  const typeObj = [
    { label: 'Immobilier', id: 1, cat: 'Logement' },
    { label: 'Comptes', id: 2, cat: '' },
    { label: 'Véhicules', id: 3, cat: 'Transport' },
    { label: 'Plan de maintenance', id: 4, cat: 'Entretien' },
    { label: 'Expériences pro (ParcoursPro)', id: 5, cat: 'Professionnel' },
    { label: 'Task (MesToDo)', id: 6, cat: '' },
    { label: 'Other', id: 7, cat: '' },
  ]
  const fetchAccounts = async () => {
    const { data, status } = await makeGetRequest(urls.fetchAccounts + '?limit=1000000', {}, true)
    if (status === 200) {
      const filterAccounts = []
      data.forEach((v) => {
        filterAccounts.push({ label: `${v.Nom?.Nom}`, id: v.id })
      })

      setAccounts([...filterAccounts])
    }
  }
  const fetchTasks = async () => {
    const { data, status } = await makeGetRequest(urls.fetchTasks + '?limit=1000000', {}, true)
    if (status === 200) {
      const filterTasks = []
      data.forEach((v) => {
        filterTasks.push({ label: `${v.Nom}`, id: v.id })
      })

      setTasks([...filterTasks])
    }
  }

  const fetchDocumentsTypes = async () => {
    const url = urls.fetchDocumentsTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Type}`, id: v.id, cat: v.categorie, domain: v.Domains })
      })
      // setTypes([...filterTypes])
      setTypesTemps([...filterTypes])
    }
  }
  const fetchImmobiliers = async () => {
    const url = urls.fetchImmobiliers + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterImmobiliers = []
      data.forEach((v) => {
        filterImmobiliers.push({ id: v.id, label: `${v.nom}` })
      })
      setImmobiliers([...filterImmobiliers])
    }
  }
  const fetchVehicules = async () => {
    const url = urls.fetchVehicles + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterVehicules = []
      data.forEach((v) => {
        filterVehicules.push({ id: v.id, label: `${v.Name}` })
      })
      setVehicules([...filterVehicules])
    }
  }
  const fetchPlanMaintenance = async () => {
    const url = urls.fetchPlanMaintenances + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterPlanMaintenances = []
      data.forEach((v) => {
        filterPlanMaintenances.push({ id: v.id, label: `${v.EquipementName}` })
      })
      setPlanMaintenance([...filterPlanMaintenances])
    }
  }
  const fetchParcours = async () => {
    const url = urls.getParcoursPro + '?ParcoursType=Expérience&limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterData = []
      data.forEach((v) => {
        filterData.push({ id: v.id, label: `${v.Name}` })
      })
      setParcoursPro([...filterData])
    }
  }
  const handleClickOpen = () => {
    setOpen(true)
    fetchAccounts()
    fetchDocumentsTypes()
    fetchImmobiliers()
    fetchVehicules()
    fetchPlanMaintenance()
    fetchParcours()
    fetchTasks()
  }

  const handleClose = () => {
    reset()
    setOpen(false)
    setFile(null)
    setTypeObject(0)
  }

  const onSubmit = async (data) => {
    const formData = new FormData()
    if (file != null) formData.append('Lien', file)
    formData.append('Type', data.Type.id)
    if (data.Affectation !== '') formData.append('Affectation', data.Affectation.id)
    if (data.Immobilier !== '') formData.append('Immobilier', data.Immobilier.id)
    if (data.Vehicules !== '') formData.append('Vehicledata', data.Vehicules.id)
    if (data.PlanMaintenance !== '') formData.append('PlanMaintenance', data.PlanMaintenance.id)
    if (data.ParcoursPro !== '') formData.append('ParcoursPro', data.ParcoursPro.id)
    if (data.TaskMesToDo !== '') formData.append('TaskMesToDo', data.TaskMesToDo.id)
    formData.append('Nom', data.Nom)
    formData.append('Description', data.Description)
    formData.append('Externe', data.Externe)
    formData.append('Datedéchéance', data.Datedéchéance)

    const response = await makePostRequest(
      urls.crudDocumentsDetailsOperations,

      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
    if (response.status === 201) {
      setOperations((operations) => ({
        ...operations,
        results: [...operations.results, response.data],
        count: operations.count + 1,
      }))
      handleClose()
    }
  }
  const handleTypeDoc = (j) => {
    j.cat
      ? setTypes(typesTemps.filter((el) => (j.id === 5 ? el.domain === j.cat : el.cat === j.cat)))
      : setTypes(typesTemps)
    setValue('Type', '')
    setSelectedTypeDoc(null)
  }
  return (
    <>
      {isMobile ? (
        <AddCircleIcon onClick={handleClickOpen} />
      ) : (
        <CustomButton onClick={handleClickOpen}>Ajouter</CustomButton>
      )}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'Black !important' }}>Ajouter Document</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => {
                handleTypeDoc(j)
                if (j.id === 1) {
                  setValue('Affectation', '')
                  setValue('Vehicules', '')
                  setValue('ParcoursPro', '')
                  setValue('TaskMesToDo', '')
                  setValue('PlanMaintenance', '')
                  setTypeObject(1)
                } else if (j.id === 2) {
                  setValue('PlanMaintenance', '')
                  setValue('Vehicules', '')
                  setValue('ParcoursPro', '')
                  setValue('TaskMesToDo', '')
                  setValue('Immobilier', '')
                  setTypeObject(2)
                } else if (j.id === 3) {
                  setValue('PlanMaintenance', '')
                  setValue('Immobilier', '')
                  setValue('ParcoursPro', '')
                  setValue('TaskMesToDo', '')
                  setValue('Affectation', '')
                  setTypeObject(3)
                } else if (j.id === 4) {
                  setValue('Vehicules', '')
                  setValue('Immobilier', '')
                  setValue('Affectation', '')
                  setValue('TaskMesToDo', '')
                  setValue('ParcoursPro', '')
                  setTypeObject(4)
                } else if (j.id === 5) {
                  setValue('Vehicules', '')
                  setValue('Immobilier', '')
                  setValue('Affectation', '')
                  setValue('PlanMaintenance', '')
                  setValue('TaskMesToDo', '')
                  setTypeObject(5)
                } else if (j.id === 6) {
                  setValue('Vehicules', '')
                  setValue('Immobilier', '')
                  setValue('Affectation', '')
                  setValue('PlanMaintenance', '')
                  setValue('ParcoursPro', '')
                  setTypeObject(6)
                } else if (j.id === 7) {
                  setValue('Vehicules', '')
                  setValue('Immobilier', '')
                  setValue('Affectation', '')
                  setValue('PlanMaintenance', '')
                  setValue('ParcoursPro', '')
                  setValue('TaskMesToDo', '')
                  setTypeObject(7)
                }
              }}
              label="Type d’objet"
              data={typeObj}
              name="TypeObj"
              required={true}
            />
            {typeObject === 1 ? (
              <ComboBox
                handleAutoComplete={(e, j) => setValue('Immobilier', j)}
                label="Immobilier"
                data={immobiliers}
                name="Immobilier"
                required={true}
              />
            ) : (
              ''
            )}
            {typeObject === 2 ? (
              <ComboBox
                handleAutoComplete={(e, j) => setValue('Affectation', j)}
                label="Nom Objet"
                data={accounts}
                name="Affectation"
                required={true}
              />
            ) : (
              ''
            )}

            {typeObject === 3 ? (
              <ComboBox
                handleAutoComplete={(e, j) => setValue('Vehicules', j)}
                label="Véhicules"
                data={vehicules}
                name="Vehicules"
                required={true}
              />
            ) : (
              ''
            )}
            {typeObject === 4 ? (
              <ComboBox
                handleAutoComplete={(e, j) => setValue('PlanMaintenance', j)}
                label="Plan de maintenance "
                data={planMaintenance}
                name="PlanMaintenance"
                required={true}
              />
            ) : (
              ''
            )}
            {typeObject === 5 ? (
              <ComboBox
                handleAutoComplete={(e, j) => setValue('ParcoursPro', j)}
                label="Parcours Pro "
                data={parcoursPro}
                name="ParcoursPro"
                required={true}
              />
            ) : (
              ''
            )}
            {typeObject === 6 ? (
              <ComboBox
                handleAutoComplete={(e, j) => setValue('TaskMesToDo', j)}
                label="Tasks (MesToDo) "
                data={tasks}
                name="TaskMesToDo"
                required={true}
              />
            ) : (
              ''
            )}
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Type', j)
                setSelectedTypeDoc(j)
              }}
              label="Type de document "
              data={types}
              name="Type"
              required={true}
              selectedValue={selectedTypeDoc}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: true }}
              name="Nom"
              label="Nom"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: false,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: false }}
              name="Description"
              label="Description"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: false,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: false }}
              name="Externe"
              label="N° Externe"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name="Datedéchéance"
              label="Datedéchéance"
            />
            <Button
              variant="contained"
              component="label"
              sx={{
                color: 'black',
                background: 'none',
                '&:hover': {
                  backgroundColor: '#aeaeae',
                },
              }}
            >
              <input
                name="file"
                type="file"
                filename={file}
                required={true}
                // accept="application/pdf"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Button>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Mettre à jour</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
